import React, { useEffect, useRef } from "react";
import { isEmpty } from "bodycodi/cmap/app/js/common";

type ClassNoticeProp = {
  PartnerClassScheduleVO: any;
};

const ClassNotice = ({ PartnerClassScheduleVO }: ClassNoticeProp) => {
  return (
    <div className="member-wrap">
      <div className="member-title">수업 공지사항</div>
      <div
        className={
          "member-memo notice" + (isEmpty(PartnerClassScheduleVO.lessonDescription) ? " empty" : "")
        }
      >
        {isEmpty(PartnerClassScheduleVO.lessonDescription) && "공지 내용이 없어요"}
        {!isEmpty(PartnerClassScheduleVO.lessonDescription) &&
          PartnerClassScheduleVO.lessonDescription}
      </div>
      <div className="hint">
        회원앱에서 수업을 예약할 때 보여집니다. 등록과 수정은 회원관리프로그램에서 할 수 있어요.
      </div>
    </div>
  );
};

export default ClassNotice;
